import { memo } from 'react'

import NextImage from 'next/image'

import { BenefitCard as BenefitCardModel } from '../benefits.model'

import * as S from './styles'

type Props = BenefitCardModel

export const BenefitCard = memo(({ image, alt }: Props) => (
  <S.Card>
    <NextImage
      src={`${process.env.NEXT_PUBLIC_SITE_IMAGES_PREFIX}/images/site/home/benefits/${image}`}
      alt={alt}
      fill
      sizes="(max-width: 767px) 80vw, 25vw"
      style={{ objectFit: 'contain' }}
    />
  </S.Card>
))

BenefitCard.displayName = 'BenefitCard'
